import { Injectable } from "@angular/core";
import { SnackbarActions } from "@app/root-store/actions";
import { ActionWord } from "@app/shared/resources/action-word";
import { HttpResponseHandler } from "@app/shared/services/http-response-handler";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Action } from "@ngrx/store";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ClareLogActions, DataActions } from "../actions";

@Injectable()
export class ClareoneLogEffects {
    constructor(private readonly actions$: Actions) {}
    UploadLogSuccess$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(ClareLogActions.ActionTypes.UploadLogSuccess),
            map((action: ClareLogActions.UploadLogSuccess) =>
                DataActions.handleSuccessMessage2(ActionWord.uploaded, "", action.payload.filepath)()
            ),
            catchError((error: any) => of(new ClareLogActions.UploadLogFailure(error)))
        )
    );

    uploadLogFailure$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(ClareLogActions.ActionTypes.UploadLogFailure),
            map((action: ClareLogActions.UploadLogFailure) =>
                SnackbarActions.openSnackbar({
                    message: new HttpResponseHandler(null, null, action.error, true),
                })
            )
        )
    );
}
